import type ProofingStore from './schema/ProofingStore';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import { IEditorClient } from '@editor/outlook-online/lib/IEditorClient';

const proofingStoreData: ProofingStore = {
    editorBxClients: new ObservableMap<string, Promise<IEditorClient>>(),
};
export const getStore = createStore<ProofingStore>('proofing', proofingStoreData);
export const proofingStore = getStore();
